import { AxiosError, AxiosResponse } from "axios";
import nodeProvider from "../providers/node.provider";

export class LoginService {
  public async auth(login: string, password: string): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.post('/login', {
        login,
        password
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}